import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { ISetPhoneApiPayload, TSetPhoneApiResponse } from '../types/PhoneVerification.api';

export const setPhone = async (payload: ISetPhoneApiPayload): Promise<TSetPhoneApiResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.patch<TSetPhoneApiResponse>(
    '/auth-service/users/phone',
    payload,
    { headers },
  );
  return data;
};
